import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { MailX, FlaskConical } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useAuth } from "../context/AuthContext";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/New_York", dateStyle: "medium", timeStyle: "short" }) : "");

export function EmailPausedBanner() {
  const { can } = useAuth();
  const { data, reload } = useApi("/admin/email-paused");
  useEffect(() => { const id = setInterval(reload, 60000); return () => clearInterval(id); }, [reload]);
  if (!data?.paused && !data?.test_mode) return null;
  if (!data.paused) return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border-2 border-amber-500 bg-amber-100 px-4 py-3 text-amber-950" role="status" data-testid="email-test-mode-banner-global">
      <div className="flex items-center gap-3">
        <FlaskConical size={20} className="shrink-0" />
        <div>
          <p className="text-sm font-bold uppercase tracking-wider">Email test mode is on</p>
          <p className="text-xs">Only <span className="font-mono-accent">{data.test_recipient}</span> receives email or SMS; everyone else is skipped{data.skipped_test > 0 ? ` (${data.skipped_test} skipped so far)` : ""}.</p>
        </div>
      </div>
      {can("admin_level") && <Link to="/admin/content?tab=settings" className="rounded-full bg-amber-950 px-4 py-1.5 text-sm font-semibold text-amber-50" data-testid="email-test-mode-link">Turn off test mode</Link>}
    </div>
  );
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border-2 border-crimson bg-crimson px-4 py-3 text-parchment shadow-lg" role="alert" data-testid="email-paused-banner-global">
      <div className="flex items-center gap-3">
        <MailX size={20} className="shrink-0" />
        <div>
          <p className="font-bold uppercase tracking-wider text-sm">Outgoing email is paused</p>
          <p className="text-xs text-parchment/85">No reminders, statements or notices are being sent{data.by ? ` — paused by ${data.by}` : ""}{data.since ? ` on ${when(data.since)}` : ""}. {data.skipped > 0 && <>{data.skipped} email{data.skipped === 1 ? "" : "s"} skipped so far.</>}</p>
        </div>
      </div>
      {can("admin_level")
        ? <Link to="/admin/content?tab=settings" className="rounded-full bg-parchment px-4 py-1.5 text-sm font-semibold text-crimson hover:bg-gold-light" data-testid="email-paused-resume-link">Resume email</Link>
        : <span className="text-xs text-parchment/85">Ask an admin to resume under Content → Payments &amp; Odwira.</span>}
    </div>
  );
}
